export default "/images/map.png?1de49cfb936cbb751281aca1ead5f081";